import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { AuthProvider } from "./contexts/AuthContext";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Directory from "./pages/Directory";
import Category from "./pages/Category";
import Article from "./pages/Article";
import Search from "./pages/Search";
import Tag from "./pages/Tag";
import Author from "./pages/Author";
import NotFound from "./pages/NotFound";
import AdminLogin from "./pages/admin/Login";
import AdminDashboard from "./pages/admin/Dashboard";
import ArticleEditor from "./pages/admin/ArticleEditor";
import AIGenerator from "./pages/admin/AIGenerator";

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/directory" element={<Directory />} />
              <Route path="/category/:slug" element={<Category />} />
              <Route path="/article/:slug" element={<Article />} />
              <Route path="/search" element={<Search />} />
              <Route path="/tag/:slug" element={<Tag />} />
              <Route path="/author/:slug" element={<Author />} />
              <Route path="/admin21" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/admin/articles/new" element={<ArticleEditor />} />
              <Route path="/admin/articles/:id/edit" element={<ArticleEditor />} />
              <Route path="/admin/generate" element={<AIGenerator />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="bottom-right" />
        </div>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
